import React, { Fragment, useState, useContext } from 'react'
import Box from '@material-ui/core/Box'

import { ActionablesContext } from '../../../contexts/ActionablesContext'
import SaveIconSvg from '../../../../../assets/images/system-icons/save.svg'
import NavigationIconSvg from '../../../../../assets/images/system-icons/layout.svg'
import SharedForm from '../../../shared/SharedForm'
import Input from '../../../shared/inputs/Input'
import Checkbox from '../../../shared/inputs/Checkbox'
import { submitSaveRetirementScenarioForm } from '../saveRetirementScenarioHelpers'
import { Button } from '../../Button'

export const NormalSaveFlow = (props) => {
  const [savingInProgress, setSavingInprogress] = useState(false)

  return (
    <Fragment>
      <h1 className='center'>{props.header}</h1>
      <div className='row'>
        <div className='small-12 columns'>
          {props.isWealthManager
            ? <NormalSaveFlowParagraphForWealthManager {...props} />
            : <NormalSaveFlowParagraphForClient {...props} />}
          <NormalSaveFlowForm
            savingInProgress={savingInProgress}
            setSavingInprogress={setSavingInprogress}
            {...props}
          />
        </div>
      </div>
    </Fragment>
  )
}

const NormalSaveFlowParagraphForWealthManager = (props) => {
  const { retirementScenarioStatus, featureToggles } = props
  const { implementable } = useContext(ActionablesContext)

  return (
    <Fragment>
      <section className='paragraph'>
        <div className='paragraph__icon'>
          <SaveIcon />
        </div>
        <div className='paragraph__text'>
          {retirementScenarioStatus === 'in_review'
            ? <p>Saving this scenario allows you to come back at any time and make further changes. The client will receive an email informing them that changes have been made to this scenario.</p>
            : <p>Saving this scenario allows you to come back at any time and make further changes.</p>}
        </div>
      </section>

      <section className='paragraph'>
        <div className='paragraph__icon'>
          <NavigationIcon />
        </div>
        <div className='paragraph__text'>
          {retirementScenarioStatus === 'in_review'
            ? <p>Approving this plan will implement it, this plan will then be accessible as the client's current plan</p>
            : <p>Implement this scenario to make it the active plan.</p>}
        </div>
      </section>

      {retirementScenarioStatus === 'in_review' && featureToggles.momentumPOC &&
        <section className='paragraph'>
          <div className='paragraph__icon'>
            <NavigationIcon />
          </div>
          <div className='paragraph__text'>
            <p>Approving this plan will generate a record of advice that will be sent to you and the client. We'll include the entire plan, any notes that you've added and any quotes that have been accepted.</p>
          </div>
        </section>}

      {!implementable &&
        <section className='paragraph'>
          <div className='paragraph__icon'>
            <NavigationIcon />
          </div>
          <div className='paragraph__text'>
            <p><strong>There are some quotes in this scenario that still need to be addressed before it can be implemented</strong></p>
          </div>
        </section>}
    </Fragment>
  )
}

const NormalSaveFlowParagraphForClient = (props) =>
  <Fragment>
    <section className='paragraph'>
      <div className='paragraph__icon'>
        <SaveIcon />
      </div>
      <div className='paragraph__text'>
        <p>Saving your scenario allows you to come back at any time and make further changes.</p>
      </div>
    </section>

    {!props.isWealthManager && props.featureToggles.scenarioReviews &&
      <section className='paragraph'>
        <div className='paragraph__icon'>
          <NavigationIcon />
        </div>
        <div className='paragraph__text'>
          <p>Send this plan for review to have your wealth manager approve your plan. We'll save this plan as part of the process.</p>
        </div>
      </section>
    }
  </Fragment>

const NormalSaveFlowForm = (props) => {
  const { implementable } = useContext(ActionablesContext)
  return (
    <SharedForm actionUrl={props.url} methodType='POST' authenticityToken={props.authenticityToken}>
      <Input
        autoFocus name='retirement_scenario[name]' id='retirement_scenario_name_input'
        label='Give your plan a name' ishalf={false}
        value={props.scenarioName} onChange={(value) => props.setScenarioName(value)}
      />

      {props.isWealthManager && !props.featureToggles.momentumPOC &&
        <div className='row'>
          <div style={{ float: 'right', marginBottom: '2rem', marginTop: '-1rem', marginRight: '1rem' }}>
            <Checkbox
              id='client_send_implement_notification_input'
              name='send_implement_notification'
              value={props.sendImplementationNoticeToClient}
              label='notify client of changes when implementing'
              onChange={(value) => props.setSendImplementationNoticeToClient(value)}
            />
          </div>
        </div>}

      {props.isWealthManager && props.featureToggles.momentumPOC &&
        <div className='row'>
          <div style={{ float: 'right', marginBottom: '2rem', marginTop: '-1rem', marginRight: '1rem' }}>
            <Checkbox
              id='advisor_delcaration_acceptance_input'
              name='advisor_declaration_acceptance'
              value={props.advisorDeclarationAcceptance}
              label={advisorDeclarationLabel(props)}
              onChange={(value) => props.setAdvisorDeclarationAcceptance(value)}
            />
          </div>
        </div>}

      <div className='row'>
        <Box
          className='flex gap-4'
        >
          <SaveButton
            {...props}
            onClick={() => submitSaveRetirementScenarioForm(props, { implement: false })}
            savingInProgress={props.savingInProgress}
          />
          {!props.isWealthManager && props.featureToggles.scenarioReviews &&
            <SaveAndSendForReviewButton
              {...props}
              onClick={() => submitSaveRetirementScenarioForm(props, { implement: false, status: 'in_review' })}
              savingInProgress={props.savingInProgress}
            />}
          {props.isWealthManager &&
            <WealthManagerAction implementable={implementable} {...props} />}
          {!props.isWealthManager && props.canImplement &&
              <SaveAndImplementButton
                {...props}
                value={'Save and Implement'}
                trackAs={'Retirement Scenario: Implement'}
                onClick={() => handleSaveAndImplement(props)}
                savingInProgress={props.savingInProgress}
              />
          }
        </Box>
        { !props.hasIdentificationNumber &&
          props.isWealthManager &&
          <span style={{float: 'right', color: 'red'}}>Client ID number is missing.</span>
        }
      </div>
    </SharedForm>
  )
}

const advisorDeclarationLabel = (props) => {
  return (
    <span>I have read and accept the <a onClick={() => props.onViewAdvisorDeclarationClick()}>declaration of advice</a></span>
  )
}

// This was moved to it's own method since there will be more conditionals and rules that come in to play later down the line.
const WealthManagerAction = (props) => {
  const { retirementScenarioStatus, advisorDeclarationAcceptance, featureToggles, implementable, hasIdentificationNumber } = props
  const disabled = (featureToggles.momentumPOC && !advisorDeclarationAcceptance) || !implementable || !hasIdentificationNumber

  return (
    <SaveAndImplementButton
      {...props}
      value={`${retirementScenarioStatus === 'in_review' ? 'Approve and Implement' : 'Save and Implement'}`}
      trackAs={retirementScenarioStatus === 'in_review' ? 'Retirement Scenario: Approve' : 'Retirement Scenario: Implement'}
      disabled={disabled}
      onClick={() => handleSaveAndImplement(props)}
      savingInProgress={props.savingInProgress}
    />
  )
}

const handleSaveAndImplement = (props) => {
  if (props.isWealthManager && props.featureToggles.momentumPOC && !props.advisorDeclarationAcceptance) {
    // Do Nothing
    return false
  } else if (props.isWealthManager && props.checkIfRiskRatingChanged() && props.featureToggles.riskChangeConfirmation) {
    props.setRiskChangedFlow(true)
  } else {
    submitSaveRetirementScenarioForm(props, { implement: true, status: 'approved' })
  }
}

const SaveIcon = () =>
  <div dangerouslySetInnerHTML={{ __html: SaveIconSvg }} />

const NavigationIcon = () =>
  <div dangerouslySetInnerHTML={{ __html: NavigationIconSvg }} />

const SaveButton = (props) =>
  <Button
    name='save'
    type='button'
    disabled={props.savingInProgress || props.disabled}
    onClick={props.onClick}
    secondary
    fullWidth
    trackAs="Retirement Scenario: Save"
    trackingDetails={{retirement_scenario_id: props.retirementScenarioId}}
  > { props.savingInProgress ? 'Saving...' : 'Save' } </Button>

const SaveAndImplementButton = (props) =>
  <Button
    name='implement'
    type='button'
    disabled={props.savingInProgress || props.disabled}
    onClick={props.onClick}
    primary
    fullWidth
    trackAs={props.trackAs}
    trackingDetails={{retirement_scenario_id: props.retirementScenarioId}}
  > { props.savingInProgress ? 'Saving...' : props.value } </Button>

const SaveAndSendForReviewButton = (props) =>
  <Button
    name='send_for_review'
    type='button'
    disabled={props.savingInProgress || props.disabled}
    onClick={props.onClick}
    primary
    fullWidth
    trackAs="Retirement Scenario: Send for Review"
    trackingDetails={{retirement_scenario_id: props.retirementScenarioId}}
  > { props.savingInProgress ? 'Saving...' : 'Send for Review' } </Button>
